import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

const END_POINT = '/booking-reviews';

export default {
  async getBookingReviewList(payload) {
    const params = getParamsFormObject(payload);
    const path = END_POINT + params;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getReviewOverviewOfBookingReview(payload) {
    const params = getParamsFormObject(payload);
    const path = `${END_POINT}/overview${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getBookingReviewDetail(payload) {
    const path = `${END_POINT}/${payload}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async postFeedbackBookingReview(payload) {
    const path = `${END_POINT}/${payload.reviewId}/feedback`;

    const response = await axiosClient.post(path, { managerFeedback: payload.managerFeedback });

    return response.data;
  },

  async updateFeedbackBookingReview(payload) {
    const path = `${END_POINT}/${payload.reviewId}/feedback`;

    const response = await axiosClient.put(path, {
      managerFeedback: payload.managerFeedback,
    });

    return response.data;
  },

  async deleteFeedbackBookingReview(reviewId) {
    const path = `${END_POINT}/${reviewId}/feedback`;

    const response = await axiosClient.delete(path);

    return response.data;
  },

  async updateBookingReview(payload) {
    const path = `${END_POINT}/${payload.reviewId}`;

    const response = await axiosClient.put(path, {
      content: payload.content,
    });

    return response.data;
  },

  async deleteBookingReview(reviewId) {
    const path = `${END_POINT}/${reviewId}`;

    const response = await axiosClient.delete(path);

    return response.data;
  },
};
